import { withSentryReactRouterV6Routing } from "@sentry/react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Survey } from "./views/statement_survey";
import { useEffect } from "react";
import { apiClient } from "./client";
const SentryRoutes = withSentryReactRouterV6Routing(Routes);

export default function App() {
  const location = useLocation();
  useEffect(() => {
    // Scroll to the top if the page changes
    window.scrollTo({ top: 0, left: 0 });
  }, [location]);

  return (
    <>
      <SentryRoutes>
        <Route index element={<Survey apiClient={apiClient} />} />
        {/* Any path that should exist should go to root */}
        <Route path="*" element={<Navigate to="/" />} />
      </SentryRoutes>
    </>
  );
}
